import { Box, Heading, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

interface IUrlQueryStringParams {
  view?: string;
}

export const ScheduleCalendarNoTracks: FC = () => {
  const { t } = useTranslation();
  const { view = 'day' } = useQueryParams<IUrlQueryStringParams>({
    view: StringParam,
  });

  return (
    <Box>
      <Heading as="h2" fontSize="25px" lineHeight={10}>
        {t('schedule.noScheduleEntries.heading')}
      </Heading>
      <Text fontSize="md" lineHeight="base">
        {t(view === 'day' ? 'schedule.noScheduleEntries.messageDay' : 'schedule.noScheduleEntries.messageWeek')}
      </Text>
    </Box>
  );
};
